const productCategory = [
  { id: 1, label: "Airpodes", value: "airpodes" },
  { id: 2, label: "Camera", value: "camera" },
  { id: 3, label: "Earphones", value: "earphones" },
  { id: 4, label: "Mobiles", value: "mobiles" },
  { id: 11, label: "Mouses", value: "Mouses" },
  { id: 5, label: "Printers", value: "printers" },
  { id: 6, label: "Refrigerator", value: "refrigerator" },
  { id: 7, label: "Speakers", value: "speakers" },
  { id: 9, label: "Televisions", value: "televisions" },
  { id: 8, label: "Trimmers", value: "trimmers" },
  { id: 10, label: "Watches", value: "watches" },
];

export default productCategory;
